import { CaseInfoBannerKey, CaseLandingViewProps } from "src/pages/case-landing/case-landing-view-model";

export function useSubmitObjectionViewProps(): CaseLandingViewProps {
    return {
      bannerKey: CaseInfoBannerKey.StartFormalObjection,
    };
}
